<template>
  <span :class="statusObj.class">
    <span
      v-if="
        data.item.status == consts.fileProcessing.completeWithError.code ||
          data.item.status == consts.fileProcessing.failed.code ||
          data.item.status == consts.fileProcessing.notCompleted.code
      "
      @click="viewErrorList(data.item.id)"
      class="error-count"
      >{{ statusObj.text
      }}<span v-if="data.item.error_count > 0">
        ({{ data.item.error_count }})</span
      ></span
    >
    <span v-else>
      {{ statusObj.text }}
    </span>
  </span>
</template>
<script>
import consts from "@/_consts";
export default {
  name: "c-transaction-status",
  props: {
    data: null,
    statusObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      consts: consts,
      modalData: {
        action: consts.modalAction.showProcessingFileErrorList,
        data: null,
        okClickHandle: null
      }
    };
  },
  methods: {
    viewErrorList(transactionId) {
      this.modalData.data = { transactionId: transactionId };
      this.$modal.show("eventModal", this.modalData);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/transaction-associated/TransactionStatus.vue